import { REPORT_TEMPLATE, type IReportCardInfo, type MarketAnalysisCardData } from '@/types';
import type { BaseCardService } from './abstract-base-card-service';
import { BaseCardServiceImpl, type BaseReportCardData } from './abstract-base-card-service';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { ReportApiService } from '@/infrastructure/api-functions/report-api-service';
import { ReferenceModelService, type IReferenceModelService } from './reference-model-service';
import _ from 'lodash'
import { I18nService } from '../i18n-service';

export const MarketAnalysisService = Symbol('MarketAnalysisService');

export type MarketAnalysisService = BaseCardService<MarketAnalysisCardData>

@injectable()
export class MarketAnalysisServiceImpl extends BaseCardServiceImpl<MarketAnalysisCardData> implements MarketAnalysisService {
    _modelData = {
        isLoading: false,
        isFailed: false,
        isSuccess: false,
        data: undefined,
    };

    templateType = REPORT_TEMPLATE.MARKET_ANALYSIS;

    constructor(
        @inject(ReportApiService) _reportApiService: ReportApiService,
        @inject(I18nService) private readonly _i18nService: I18nService,
        @inject(ReferenceModelService) _referenceService: IReferenceModelService
    ) {
        super(_reportApiService, _referenceService);
    }

    private _generateObjectives(cardData: BaseReportCardData<IReportCardInfo>): MarketAnalysisCardData {
        const marketData = cardData.data?.[REPORT_TEMPLATE.MARKET_ANALYSIS]?.OBJECTIVES_GPT
        return {
            description: marketData?.content?.join('\n\n') || this._i18nService.t('report.noData'),
            rag_list: marketData?.rag_list || [],
        }
    }

    updateFetchData(getUpdateValue: (v: BaseReportCardData<IReportCardInfo>) => BaseReportCardData<IReportCardInfo>): void {
        const updatedValue = getUpdateValue(_.omit(this.modelData, 'data'));

        const dataHaveFromUpdated = _.has(updatedValue, 'data')
        if (dataHaveFromUpdated) {
            const generatedData = this._generateObjectives(updatedValue);
            this.update(modelData => ({
                ...modelData,
                ...updatedValue,
                data: generatedData,
            }));
            this._autoRegisterReferences(generatedData.rag_list || []);
        } else {
            this.update(m => ({
                ...m,
                ...updatedValue,
                data: m.data,
            }));
        }
    }
}
